module.exports = __webpack_public_path__ + "static/media/banner.e0e01315.png";